import { h, Component } from 'preact';
import { Text } from 'preact-i18n';

export default class PaywallCta extends Component {
    render() {
        return (
            <div class='card border-0 shadow-sm my-4'>
                <div class='card-body text-center p-4'>
                    <div class='mb-2'>
                        <i class='fa-solid fa-lock fa-2x text-body-secondary' />
                    </div>
                    <h5 class='card-title'>
                        <Text id='paywall.title'>This article is for members</Text>
                    </h5>
                    <p class='card-text text-body-secondary'>
                        <Text id='paywall.body'>Become a member to read the full article and support our journalism.</Text>
                    </p>
                    <a href='/bli-medlem' class='btn btn-primary btn-lg'>
                        <Text id='paywall.cta'>Become a member</Text>
                    </a>
                </div>
            </div>
        );
    }
}
